module.exports = __webpack_public_path__ + "src/assets/img/page9/36e60f72982707e933496eec2f985538.jpg";